import styles from "./styles.module.scss";
import cn from "classnames";

export const LargeImage = ({ image, className }) => {
  return (
    <section className={cn(styles.LargeImage, className)}>
      <img
        src={image?.url}
        alt=""
        className={styles.image}
        data-sourceflow-prop="image"
      />
    </section>
  );
};

export default LargeImage;
